<mat-dialog-content>
  <iframe id="alertsIFrame" [src]="alertsModalUrl | safe" *ngIf="dialogRef"
          style="margin: 0%; height: 100%; width: 100%; border: none">
  </iframe>
</mat-dialog-content>
